import { apiFetch } from "../utils/apiFetch";
import { API_BASE_CLIENT as API_BASE } from "../config/vars";

export async function getClientBillingSummary() {
    const res = await apiFetch(`${API_BASE}/billing/client/summary`);
    if (!res.ok) {
        const txt = await res.text();
        throw new Error(txt || "Не вдалося завантажити оплату");
    }
    return await res.json();
}

export async function getClientBillingBreakdown() {
    const res = await apiFetch(`${API_BASE}/billing/client/breakdown`);
    if (!res.ok) {
        const txt = await res.text();
        throw new Error(txt || "Не вдалося завантажити деталізацію оплати");
    }
    return await res.json();
}

export async function getClientBillingExpenses() {
    const res = await apiFetch(`${API_BASE}/billing/client/expenses`);
    if (!res.ok) {
        const txt = await res.text();
        throw new Error(txt || "Не вдалося завантажити склад тарифу");
    }
    return await res.json();
}
